/**
 * @generated SignedSource<<4799f6e751b163a792d22203aed4b11f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type useIsCurrentUserPublic_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly clientClass: ClientClass | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useIsCurrentUserPublic_session";
};
export type useIsCurrentUserPublic_session$key = {
  readonly " $data"?: useIsCurrentUserPublic_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsCurrentUserPublic_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsCurrentUserPublic_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientClass",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "946b0a86e80b74994db3435eb3a4c5a5";

export default node;
